export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * Format question number with leading zero for numbers less than 10
 * @param order - The question order number
 * @returns Formatted question number (e.g., "01", "02", "10", "15")
 */
export const formatQuestionNumber = (order: number): string => {
  return order < 10 ? `0${order}` : `${order}`;
};
